<template>
    <div class="main">
        <topback title="My Team" path="back"></topback>
        <card class="team-card" color="#f3f3f6">
            <div slot="card-body">
                <md-cell-item title="Invite Link Manage" arrow @click="goto_invitelinkmanage">
                    <div class="holder" slot="left">
                        <iconimg name="team" size="lg"></iconimg>
                    </div>
                </md-cell-item>
                <md-cell-item :title="'Parent: ' + teaminfo.parent_collectionworkerid" addon="Contact" arrow @click="contact_parent">
                    <div class="holder" slot="left">
                        <iconimg name="service" size="lg"></iconimg>
                    </div>
                </md-cell-item>

                <md-cell-item :title="'Leader: ' +  teaminfo.collectionworkerid" :addon="'BR: ' + teaminfo.bonus_ratio + ' %'">
                    <div class="holder" slot="left">
                        <iconimg name="leader" size="lg"></iconimg>
                    </div>
                </md-cell-item>
                <md-cell-item :title="'Commission: ₹ ' +  teaminfo.commission" :addon="'TR: ₹ ' + teaminfo.team_recharge">
                    <div class="holder" slot="left">
                        <iconimg name="commission" size="lg"></iconimg>
                    </div>
                </md-cell-item>
            </div>
        </card>

        <md-field-item title="Team Members" :plain="true">
            <!-- <span slot="right" @click="go_buy_tutorial">Buy Tutotial</span> -->
            
            <div class="team-list" slot="children">
                <div class="noassets" v-if="nodata">
                    <md-result-page class="customized" img-url="/static/icon/noassets.png" text="No member yet"
                        subtext="">
                    </md-result-page>
                    <md-button class="mt-3" type="primary" @click="goto_invitelinkmanage">Add Invite link</md-button>
                </div>
                <md-scroll-view  ref="listscrollView" :scrolling-x="false" @refreshing="$_onRefresh" :auto-reflow="true" :immediate-check-end-reaching="true"
                    @end-reached="$_onEndReached">
                    <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
                        :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"
                        refresh-text="pull to refresh" refresh-active-text="release refreshable"
                        refreshing-text="refresh"></md-scroll-view-refresh>
                        <md-field class="historylist pt-0">
                            <myteamitem :ch="ch" v-for="ch in children" v-bind:key="ch.id"></myteamitem>
                        </md-field>
                    <md-scroll-view-more slot="more" :is-finished="isFinished" loading-text="Loading" finished-text="no more data">
                    </md-scroll-view-more>
                </md-scroll-view>
            </div>
        </md-field-item>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import card from '@/components/card'
import myteamitem from './myteamitem'
import { Dialog } from 'mand-mobile'
import { getmyteam } from '@/request/api'

export default {
    name: 'myteam',
    components: {
        [topback.name]: topback,
        iconimg,
        card,
        myteamitem
    },
    data() {
        return {
            teaminfo: {},
            page: 1,
            limit: 1,
            parent: "",
            isFinished: false,
            nodata: true,
            children: []
        }
    },
    watch: {

    },
    mounted() {
        window.ScrollViewTrigger2 = () => {
            this.$refs.listscrollView.triggerRefresh();
        }
    },
    created() {
    },
    methods: {
        $_onRefresh() {
            this.children = [];
            this.page = 1;
            this.isFinished = true;
            this.get_myteam(true);
        },
        $_onEndReached() {
            if (this.isFinished) {
                return
            }
            this.get_myteam(false);
        },
        get_myteam(refresh) {
            let request_data = {
                page: this.page,
                limit: this.limit
            }
            if(this.parent !== "") {
                request_data.parent = this.parent
            }
            this.$toast.loading("Loading..")
            getmyteam(request_data).then(res=>{
                let that = this;
                setTimeout(() => {
                    that.$toast.hide();
                }, 300);
                if(res.code === 200) {
                    this.teaminfo = res.data;
                    if (res.data.count === 0) {
                        this.nodata = true;
                    } else {
                        this.nodata = false;
                        this.children = this.children.concat(res.data.children);
                    }
                    if (this.children.length < res.data.count) {
                        this.page = this.page + 1;
                        this.isFinished = false;
                    } else {
                        this.isFinished = true;
                    }
                } else {
                    this.$toast.failed(res.errmsg);
                }
                if(refresh) {
                    this.$refs.listscrollView.finishRefresh();
                    this.$refs.listscrollView.finishLoadMore();
                } else {
                    this.$refs.listscrollView.finishLoadMore();
                }
            });
        },
        goto_invitelinkmanage() {
            this.$router.push("/invitelinkmanage");
        },
        illustrate() {
            Dialog.alert({
                title: 'Tipp',
                content: 'You recommend A-level members to buy Itoken and you will get a 0.3% reward <br><br>Your B-level members recommended by your A-level members will get 0.1% reward for buying Itoken',
                confirmText: 'Got it',
                onConfirm: () => {},
            })
        },
        contact_parent() {
            this.$toast.succeed('Please contact your referee');
        }
    }
}
</script>


<style scoped>
.team-list {
    height: 10rem;
}
.holder {
  line-height: 0px;
  font-size: 39px;
}

.card {
    margin: 0.9rem 0 0 0 !important;
}
.noassets {
    margin-top: 1.5rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>


// WEBPACK FOOTER //
// src/views/my/myteam.vue